<template>
  <div class="col">
    <b-form-group
      :label="labelName"
      label-cols="4"
      label-cols-sm="3"
      label-cols-md="auto"
      label-class="text-secondary"
      :description="descriptionText"
    >
      <div class="form-row align-items-center dateBox">
        <div class="position-relative col fromDate">
          <input
            type="text"
            class="form-control from_date"
            ref="fromDate"
            :value="startDate"
            @input="update($event.target.value)"
          />
          <i class="far fa-calendar-alt receiptStartDateIcon" @click="showDate('fromDate')"></i>
        </div>
        <div class="col-auto dateTxt">-</div>
        <div class="position-relative col fromDate">
          <input
            type="text"
            class="form-control to_date"
            ref="toDate"
            :value="endDate"
            @input="update($event.target.value)"
          />
          <i class="far fa-calendar-alt receiptStartDateIcon" @click="showDate('toDate')"></i>
        </div>
      </div>
    </b-form-group>
  </div>
</template>
<script>
import '../plugins/bootstrap-datepicker/bootstrap-datepicker.css';
import '../plugins/bootstrap-datepicker/bootstrap-datepicker';
// const moment = require('moment')
export default {
  name: 'Date',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: '',
    },
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    // label名稱
    labelName: {
      type: String,
      default: '',
    },
    descriptionText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      upIsSearch: false,
      newStartDate: '',
      getEnd: 0,
      startDateUp: '',
      endDateUp: '',
    };
  },
  mounted() {
    const vm = this;
    $(this.$refs.fromDate)
      .datepicker({
        format: 'twy/mm/dd',
        autoclose: true,
        endDate: new Date(),
        startDate: new Date(1912, 1, 1),
      })
      .on('changeDate', (e) => {
        this.newStartDate = e;
        if (e.date !== null && e.date !== undefined && e.date !== '') {
          this.startDateUp = new Date(e.date.valueOf());
          const endDate = new Date(
            new Date(e.date.valueOf()).setMonth(new Date(e.date.valueOf()).getMonth() + 3)
          );
          $('.to_date').datepicker('setStartDate', this.startDateUp);
          $('.to_date').datepicker('setEndDate', endDate);
        } else {
          this.startDateUp = null;
        }

        vm.$emit(
          'inputStartDateVids',
          this.$moment(this.startDateUp).format('yyyy-MM-DD 00:00:00.000')
        );

        this.endDateUp = null;
        $('.to_date').val('');
        vm.$emit('inputEndDateVids', this.endDateUp);
      })
      .on('clearDate', () => {
        $('.to_date').datepicker('setStartDate', null);
        this.startDateUp = null;
        vm.$emit('inputStartDateVids', this.startDateUp);

        // 刪除結束值
        this.endDateUp = null;
        // vm.$emit('inputEndDate', this.endDateUp);
        vm.$emit('inputEndDateVids', this.endDateUp);
        // this.endDate = null;
      });
    $(this.$refs.toDate)
      .datepicker({
        format: 'twy/mm/dd',
        startDate: new Date(1912, 1, 1),
        // autoclose: true,
        // endDate: new Date(this.getEnd),
        // endDate: '+1m',
      })
      .on('changeDate', (e) => {
        if (e.date !== null && e.date !== undefined && e.date !== '') {
          this.endDateUp = new Date(e.date.valueOf());
        } else {
          this.endDateUp = null;
        }
        vm.$emit(
          'inputEndDateVids',
          this.$moment(this.endDateUp).format('yyyy-MM-DD 23:59:59.999')
        );
      })
      .on('clearDate', () => {
        $('.from_date').datepicker('setEndDate', null);
        this.endDateUp = null;
        vm.$emit('inputEndDateVids', this.endDateUp);
      });
  },
  methods: {
    /** 顯示 */
    // showFromDate() {
    //   $(this.$refs.fromDate).datepicker('show');
    // },
    showDate(val) {
      $(this.$refs[val]).datepicker('show');
    },
    update(v) {
      console.log(v);
      this.$emit('input', v);
    },
  },
};
</script>
